import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/inventario/tipoProducto';
import Tipos from './tipoProducto';


const ms2p = (state) => {
  return {
    ...state.tipoProducto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Tipos);
